'use client';
import { useFloating, size, offset, shift, limitShift, flip, inline, arrowSafe } from '@s7/floating';
import { useUncontrolled, useDidUpdate } from '@s7/hooks';
import { isBoolean } from '@s7/utils';
import { useFloatingAutoUpdate } from '../Floating/useFloatingAutoUpdate.js';

function getPopoverMiddlewares(options) {
    var middlewares = [
        offset(options.offset)
    ];
    if (options.middlewares.shift) {
        middlewares.push(shift({
            limiter: limitShift()
        }));
    }
    if (options.middlewares.flip) {
        middlewares.push(flip());
    }
    if (options.middlewares.inline) {
        middlewares.push(inline());
    }
    middlewares.push(arrowSafe({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    return middlewares;
}
function usePopover(options) {
    var _useUncontrolled = useUncontrolled({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    }), _opened = _useUncontrolled[0], setOpened = _useUncontrolled[1];
    var onClose = function() {
        options.onClose == null ? void 0 : options.onClose.call(options);
        setOpened(false);
    };
    var onToggle = function() {
        if (_opened) {
            options.onClose == null ? void 0 : options.onClose.call(options);
            setOpened(false);
        } else {
            options.onOpen == null ? void 0 : options.onOpen.call(options);
            setOpened(true);
        }
    };
    var floating = useFloating({
        placement: options.position,
        middleware: [].concat(getPopoverMiddlewares(options), options.width === "target" ? [
            size({
                apply: function apply(param) {
                    var rects = param.rects;
                    var _floating_refs_floating_current;
                    var _floating_refs_floating_current_style;
                    Object.assign((_floating_refs_floating_current_style = (_floating_refs_floating_current = floating.refs.floating.current) == null ? void 0 : _floating_refs_floating_current.style) != null ? _floating_refs_floating_current_style : {}, {
                        width: "" + rects.reference.width + "px"
                    });
                }
            })
        ] : [])
    });
    useFloatingAutoUpdate({
        opened: options.opened,
        position: options.position,
        positionDependencies: options.positionDependencies,
        floating: floating
    });
    useDidUpdate(function() {
        options.onPositionChange == null ? void 0 : options.onPositionChange.call(options, floating.placement);
    }, [
        floating.placement
    ]);
    useDidUpdate(function() {
        if (!options.opened) {
            options.onClose == null ? void 0 : options.onClose.call(options);
        } else {
            options.onOpen == null ? void 0 : options.onOpen.call(options);
        }
    }, [
        options.opened
    ]);
    return {
        floating: floating,
        controlled: isBoolean(options.opened),
        opened: _opened,
        onClose: onClose,
        onToggle: onToggle
    };
}

export { usePopover };
